import { goToLoginPage, logout } from '@/utils'
import { i18n } from '../../i18n'
import router from '@/router'

/**
 * 모달을 열도록 요청한다.
 * @param {*} context
 * @param {Object} option - 옵션 값 { type: '', header: '', message: '', callback: ()=>{}}
 */
const openModal = (context, option) => {
  context.commit('OPEN_MODAL', option)
}
/**
 * 모달을 닫도록 요청한다.
 * @param {*} context
 */
const closeModal = context => {
  context.commit('CLOSE_MODAL')
}
/**
 * 리워드 상품을 장바구니에 담기 한 경우 메세지를 노출한다.
 * @param {*} param0
 */
const openModalRewardCart = (context, func) => {
  context.commit('OPEN_MODAL', {
    type: 'confirm',
    message: i18n.t('alert.reward_cart'),
    callback: () => {
      func()
    }
  })
}
/**
 * 장바구니에 상품이 담긴 후 표시할 모달을 열도록 요청한다.
 * @param {*} context
 */
const openModalGoToCart = context => {
  context.commit('OPEN_MODAL', {
    type: 'confirm',
    message: i18n.t('alert.go_to_cart'),
    callback: () => {
      router.push({ path: '/cart' })
    }
  })
}
/**
 * 로그인 요청을 한다
 * @param {*} context
 * @params {String} path - 호출한 경로
 */
const openModalLogin = (context, pathName) => {
  context.commit('OPEN_MODAL', {
    type: 'confirm',
    message: i18n.t('alert.confirm_login_G02'),
    callback: goToLoginPage,
    closeCallback: () => {
      if (/search|coupon|purchase|cancel|cart|order/g.test(pathName)) {
        router.push({ path: '/' })
      }
    }
  })
}
/**
 * 세션 만료시 모달을 표시한다.
 * @param {*} context
 */
const openModalSessionExpired = context => {
  context.commit('OPEN_MODAL', {
    type: 'alert',
    message: i18n.t('alert.session_expired_G03'),
    callback: logout
  })
}
/**
 * 상품 구매전 인증이 안되어 있을 경우 표시할 모달을 열도록 요청한다.
 * @param {*} context
 */
/* const openModalAuth = context => {
  context.commit('OPEN_MODAL', {
    type: 'confirm',
    message:
      '상품 구매는 본인인증후<br>이용할 수 있습니다.<br>넥슨닷컴에서 본인인증 해주세요.',
    callback: () => alert(1)
  })
} */
/**
 * 최근 본 상품에 있는 특정 상품을 삭제할 경우 표시할 모달을 열도록 요청한다 .
 * @param {*} param0
 * @param {string} productId - 상품 id
 */
const openModalRemoveRecentProduct = ({ commit, dispatch }, productId) => {
  commit('OPEN_MODAL', {
    type: 'confirm',
    message: i18n.t('alert.delete_recent_product_D04'),
    callback: () => {
      dispatch('recent/removeRecentProduct', productId, { root: true })
    }
  })
}
/**
 * 장바구니에 있는 특정 상품을 삭제할 경우 표시할 모달을 열도록 요청한다 .
 * @param {*} param0
 * @param {string} productId - 상품 id
 */
const openModalRemoveProductFromCart = ({ commit, dispatch }, productId) => {
  commit('OPEN_MODAL', {
    type: 'confirm',
    message: i18n.t('alert.delete_product'),
    callback: () => {
      dispatch('cart/removeProductOfCart', productId, { root: true }).then(
        () => {
          dispatch('openModalRemoveCompleteFromCart')
        }
      )
    }
  })
}
/**
 * 장바구니에서 선택된 상품들을 삭제할 경우 표시할 모달을 열도록 요청한다.
 * @param {*} param0
 * @param {Array} products - 상품 배열
 */
const openModalRemoveSelectedProductFromCart = ({ commit, dispatch }) => {
  commit('OPEN_MODAL', {
    type: 'confirm',
    message: i18n.t('alert.delete_cart_product'),
    callback: () => {
      dispatch('cart/removeProductOfCart', null, {
        root: true
      }).then(() => {
        dispatch('openModalRemoveCompleteFromCart')
      })
    }
  })
}
/**
 * 장바구니에 있는 상품이 삭제된 후 호출된 모달을 열도록 요청한다.
 * @param {*} param0
 */
const openModalRemoveCompleteFromCart = ({ commit }) => {
  commit('OPEN_MODAL', {
    type: 'alert',
    message: i18n.t('alert.delete_cart_product_complete')
  })
}

/**
 * 한번에 구매할 수 있는 갯수제한 모달을 요청한다.
 * @param {*} param0
 * @param {Number} count - 제한된 갯수
 */
const openModalOrderLimitByOne = ({ commit }, count) => {
  commit('OPEN_MODAL', {
    type: 'alert',
    message: i18n.t('alert.modal_order_limit_by_one_B22', {
      count
    })
  })
}

/**
 * 한 유저가 구매할 수 있는 갯수제한 모달을 요청한다.
 * @param {*} param0
 * @param {Object} param1
 * @param {Number} param1.count - 제한된 갯수
 * @param {Number} param1.rest - 남은 구매 가능 갯수
 */
const openModalOrderLimitByUser = ({ commit }, { count, rest }) => {
  const message = i18n.t('alert.order_limit_by_user_B23', {
    count,
    restMeesage:
      rest > 0 ? i18n.t('alert.order_limit_by_user_rest_B24', { rest }) : ''
  })

  commit('OPEN_MODAL', {
    type: 'alert',
    message
  })
}

/**
 * 판매가능한 수량이 제한되어 있을 경우 남아있는 수량에 맞춰서 메세지를 노출한다.
 * @param {*} param0
 * @param {Number} count - 제한된 갯수
 */
const openModalOrderLimitByRemainQuantity = ({ commit }, count) => {
  commit('OPEN_MODAL', {
    type: 'alert',
    message: i18n.t('alert.order_limit_by_remain_quantity_B38', { count })
  })
}

/**
 * 배송, 펀딩 상품인 경우 - 바로구매, 장바구니 담기 -> 만 14세 이하 유저 체크
 */
const openModalOrderLimitByAge = ({ commit }) => {
  const message = i18n.t('alert.order_limit_by_age')
  commit('OPEN_MODAL', {
    type: 'alert',
    message
  })
}

/**
 * 구매 상세 내역 - 주문 취소
 */
const openModalRevokePurchase = ({ commit }, func) => {
  commit('OPEN_MODAL', {
    type: 'confirm',
    message: i18n.t('alert.revoke_purchase'),
    callback: () => {
      func()
    }
  })
}

/**
 * 구매 상세 내역 - 구매 확정
 */
const openModalConfirmPurchase = ({ commit }, func) => {
  commit('OPEN_MODAL', {
    type: 'confirm',
    message: i18n.t('alert.confirm_purchase'),
    callback: () => {
      func()
    }
  })
}

const setNoFooter = ({ commit }, value) => {
  commit('SET_NO_FOOTER', value)
}

export default {
  openModal,
  closeModal,
  setNoFooter,
  openModalRewardCart,
  openModalGoToCart,
  openModalLogin,
  openModalRemoveRecentProduct,
  openModalRemoveProductFromCart,
  openModalRemoveSelectedProductFromCart,
  openModalRemoveCompleteFromCart,
  openModalSessionExpired,
  openModalOrderLimitByOne,
  openModalOrderLimitByUser,
  openModalOrderLimitByRemainQuantity,
  openModalOrderLimitByAge,
  openModalRevokePurchase,
  openModalConfirmPurchase
}
